import React, { useEffect, useState } from 'react'
import { salonAPI } from '../services/api'
import StaffCard from '../components/StaffCard'
import LoadingSpinner from '../components/LoadingSpinner'
import { useStudio } from '../context/StudioContext'

export default function Team() {
  const { studio } = useStudio()
  const [staff, setStaff] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await salonAPI.getStaff()
        setStaff(response.data)
      } catch (error) {
        console.error('Error fetching staff:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStaff()
  }, [])

  return (
    <div className="pb-20">
      <section className="section-shell page-section">
        <div className="surface-card px-6 py-10 sm:px-10">
          <p className="eyebrow">Inside the studio</p>
          <h1 className="mt-4 font-heading text-5xl text-stone-900 sm:text-6xl">The people and roles behind the Maya experience.</h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-stone-600 sm:text-base">
            Public Instagram content gives a clear picture of the studio identity: nail care, beauty detail, Triton Laser expertise, and bilingual client support. This page organizes that identity into the roles clients interact with most.
          </p>
        </div>
      </section>

      <section className="section-shell page-section">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className="grid gap-6 xl:grid-cols-3">
            {staff.map((member) => (
              <StaffCard key={member.id} member={member} />
            ))}
          </div>
        )}
      </section>

      <section className="section-shell">
        <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="surface-card p-8 sm:p-10">
            <p className="eyebrow">Why clients trust the studio</p>
            <div className="mt-6 grid gap-6 md:grid-cols-2">
              {(studio?.promises || []).map((promise) => (
                <div key={promise.title}>
                  <h2 className="font-heading text-3xl text-stone-900">{promise.title}</h2>
                  <p className="mt-3 text-sm leading-7 text-stone-600">{promise.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="surface-card p-8 sm:p-10">
            <p className="eyebrow">Studio profile</p>
            <div className="mt-6 space-y-4">
              {(studio?.contactMethods || []).map((item) => (
                <a key={item.label} href={item.href} className="block rounded-[1.5rem] border border-stone-200 bg-stone-50 px-5 py-4 transition hover:border-stone-300 hover:bg-white">
                  <p className="text-xs uppercase tracking-[0.18em] text-stone-500">{item.label}</p>
                  <p className="mt-2 text-lg font-semibold text-stone-900">{item.value}</p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
